import './App.css';

// import NavBar from './components/NavBar';
import Hero from './components/Hero';
import About from './components/About';
import ProductsServices from './components/ProductsServices';
import Feedbacks from './components/Feedbacks';
import OurTeam from './components/OurTeam';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Hero />
      <About />
      <ProductsServices />
      <Feedbacks />
      <OurTeam />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
